﻿import React, { useRef, useEffect, useLayoutEffect } from 'react';

const MapControlsWidget = ({ map }) => {
  const refZoomControls = useRef(null);
  const refFullscreenControls = useRef(null);
  const elementToSendFullscreen = map.getDiv().firstChild;

	const zoomInHandler = () => map.setZoom(map.getZoom() + 1);
  const zoomOutHandler = () => map.setZoom(map.getZoom() - 1);
  const fullScreenToggleHandler = () => {
    if (isFullscreen(elementToSendFullscreen))
      exitFullscreen();
    else
      requestFullscreen(elementToSendFullscreen);
  };

  const isFullscreen = (element) => ((document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) === element);

  const requestFullscreen = (element) => {
    if (element.requestFullscreen)
      element.requestFullscreen();
    else if (element.webkitRequestFullScreen)
      element.webkitRequestFullScreen();
    else if (element.mozRequestFullScreen)
      element.mozRequestFullScreen();
    else if (element.msRequestFullScreen)
      element.msRequestFullScreen();
  }

  const exitFullscreen = () => {
    if (document.exitFullscreen)
      document.exitFullscreen();
    else if (document.webkitExitFullscreen)
      document.webkitExitFullscreen();
    else if (document.mozCancelFullScreen)
      document.mozCancelFullScreen();
    else if (document.msExitFullscreen)
      document.msExitFullscreen();
  }

  useEffect(() => {
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(refZoomControls.current);
    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(refFullscreenControls.current);

    document.onwebkitfullscreenchange = document.onmsfullscreenchange = document.onmozfullscreenchange = document.onfullscreenchange = () => {
      if (isFullscreen(elementToSendFullscreen))
        refFullscreenControls.current.classList.add("is-fullscreen");
      else
        refFullscreenControls.current.classList.remove("is-fullscreen");
    };
  }, [])


  return (
    <React.Fragment>
      <div className="controls zoom-control" ref={refZoomControls}>
        <button className="zoom-control-in" aria-label="Zoom In" onClick={zoomInHandler}>
          <span>
            <svg viewBox="0 0 16 16" height="16" width="16" fill="currentColor" focusable="false"><path fillRule="evenodd" clipRule="evenodd" d="M7 1a1 1 0 0 1 2 0v14a1 1 0 1 1-2 0V1z"></path><path fillRule="evenodd" clipRule="evenodd" d="M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"></path></svg>
          </span>
        </button>
        <div className="zoom-control-divider"></div>
        <button className="zoom-control-out" aria-label="Zoom Out" onClick={zoomOutHandler}>
          <span>
            <svg viewBox="0 0 16 16" height="16" width="16" fill="currentColor" focusable="false"><path fillRule="evenodd" clipRule="evenodd" d="M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"></path></svg>
          </span>
        </button>
      </div>
      {/*<div className="controls fullscreen-control" ref={refFullscreenControls}>*/}
      {/*  <button aria-label="Toggle fullscreen" onClick={fullScreenToggleHandler} />*/}
      {/*</div>*/}
    </React.Fragment>
  )
}

export default MapControlsWidget;
